import Button from 'gatsby-theme-core/src/components/button/index';

export default Button;
